export default __webpack_public_path__ + "static/media/2_of_diamonds.a51b192d.png";